import Modal from "react-bootstrap/Modal";

interface Props {
    show: boolean;
    onHide: () => void;
}

const ScriptModal = ({
    show,
    onHide,
}: Props) => {
    return (
        <Modal
            className="assign-clinical-form-modal"
            show={show}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static" // Prevents closing on outside click
            keyboard={false} // Prevents closing on pressing the "Escape" key
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Consents
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-12">
                        <ol className="m-0 p-0 px-5" style={{textAlign: 'justify'}}>
                            <li className="pb-2">Before we schedule your appointment, since this is a healthcare service, we need to get your agreement to participate. I'll quickly read a statement, and once you agree, we can move forward with scheduling.</li>
                            <li className="pb-2">By participating in the Wellinks program, you're giving our care team access to your medical record, allowing us to coordinate your care and communicate effectively with your healthcare providers about your health.</li>
                            <li className="pb-2">Your information is protected by Wellinks' privacy standards, and if you have any questions or want to review our full policies, you can let me know at any time.</li>
                            <li>Would you like to proceed and schedule your first appointment?</li>
                        </ol>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-between">
                <button
                    type="button"
                    className="btn btn-secondary rounded-pill px-6 my-0 ms-auto"
                    onClick={onHide}
                >
                    Close
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default ScriptModal;
